import { formatAmount } from '@dxb-web-ui-framework/common/utils/Math';
import { isDefined } from '@dxb-web-ui-framework/common/utils';
import { useLanguage } from '../../../internationalization/src/contexts/Internationalization/hooks';
import { ConsolidatedTransactionDetails } from '../domain/Transaction/entities/ConsolidatedTransaction';
import { OrderChargesResponseBody } from '../../../fundTransfer/src/domain/Transfer/entities/OrderChargesResponseDTO';

export const useTransactionCharges = (
  transactionDetails: ConsolidatedTransactionDetails,
  orderCharges?: OrderChargesResponseBody,
  error?: any,
) => {
  const language = useLanguage();
  const numberFormat = language.cultureName;

  if (isDefined(error) && !!transactionDetails) {
    return {
      commisionAmount: formatAmount(
        transactionDetails?.trxCommissionAmount as number,
        transactionDetails.accountCurrency,
        2,
        numberFormat,
      ),
      totalCharges: formatAmount(
        transactionDetails?.trxSettlementAmount as number,
        transactionDetails.accountCurrency,
        2,
        numberFormat,
      ),
    };
  }

  if (!transactionDetails) {
    return {
      commisionAmount: '-',
      totalCharges: '-',
    };
  }

  if (orderCharges) {
    return {
      commisionAmount: formatAmount(
        orderCharges?.commissionAmount as number,
        transactionDetails.accountCurrency,
        2,
        numberFormat,
      ),
      totalCharges: formatAmount(
        orderCharges?.expensesAmount as number,
        transactionDetails.accountCurrency,
        2,
        numberFormat,
      ),
    };
  }

  return {
    commisionAmount: formatAmount(
      transactionDetails?.trxCommissionAmount as number,
      transactionDetails.accountCurrency,
      2,
      numberFormat,
    ),
    totalCharges: formatAmount(
      transactionDetails?.trxSettlementAmount as number,
      transactionDetails.accountCurrency,
      2,
      numberFormat,
    ),
  };
};
